export const MUTATION_KEYS = {
    check_bad_words: 'check-bad-words'
}

export const QUERY_KEYS = {
    bad_words: 'bad-words',
    bad_links: 'bad-links'
}
